<ion-content style="overflow: hidden">
    <div class="flex-column" style="width: 100%; height: 100%; gap: 3vw; padding: 6vw; overflow: hidden">
        <div class="flex-grow flex-column flex-center-center" style="gap: 6vw;">
            <div style="font-family: 'Silka Regular'; font-size: 35px; font-weight: bold; color: var(--ion-color-primary)">Yay!</div>
            <img src="assets/img/world_with_plants.svg">
            <div style="font-family: 'Silka Regular'; font-size: 20px; font-weight: 600; text-align: center; color: var(--ion-color-primary)">
                Dein Account wurde erfolgreich erstellt!
            </div>
            <div *ngIf="emailVerifyNeeded" style="font-family: 'Marmelad'; font-size: 15px;">
                Bitte bestätige bis zum nächsten App-Start noch deine Email-Adresse. Wenn Du keine E-Mail erhalten hast,
                schaue in deinem Spam-Ordner nach.<br><br>
                Ansonsten kannst Du jetzt ganz normal mit idoplanty weiter machen wie bisher.
            </div>
            <div *ngIf="!emailVerifyNeeded" style="font-family: 'Marmelad'; font-size: 15px;">
                Du kannst jetzt ganz normal mit idoplanty weiter machen wie bisher.
            </div>
        </div>
        <app-generic-button [expand]="true" text="Weiter geht's" (clicked)="dismiss();"></app-generic-button>
    </div>
</ion-content>
